module.exports = __webpack_public_path__ + "img/symbol_9.8df79e76.png";